module.exports = __webpack_public_path__ + "fonts/Decimal-Light.4969087.woff";